import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Grid,
	TextField,
} from "@material-ui/core";
import React from "react";
import { ErrorModal } from "../components/modals/error-modal";
import { MESApiService } from "../services";

export function ChangePassword(props: any) {
	const { onClose, userId, open } = props;
	//states
	const [password, setPassword] = React.useState("");
	const [confirmPassword, setConfirmPassword] = React.useState("");
	const [canChange, setCanChange] = React.useState(false);
	const [error, setError] = React.useState<any>("");
	//functions
	const handleCancel = () => {
		onClose(false);
	};
	const handleOk = () => {
		if (userId >= 0) {
			const apiService = new MESApiService();
			apiService.changePassword(userId, password).then((response) => {
				if (apiService.hasErrors) {
					setError(apiService.error);
				} else {
					onClose(true);
				}
			});
		} else {
			onClose(false);
		}
	};
	//efects
	React.useEffect(() => {
		setCanChange(password === confirmPassword && password.length > 0);
	}, [password, confirmPassword]);
	React.useEffect(() => {
		setPassword("");
		setConfirmPassword("");
	}, [userId, open]);
	return (
		<>
			<Dialog
				onClose={() => {}}
				aria-label={"Change Password"}
				maxWidth="xs"
				aria-labelledby="confirmation-dialog-title"
				open={open}
			>
				<DialogTitle id="confirmation-dialog-title">
					{"Change Password"}
				</DialogTitle>
				<DialogContent dividers>
					<Grid container spacing={2}>
						<Grid item md={12}>
							<TextField
								aria-readonly
								label="Password"
								value={password}
								onChange={(e) => setPassword(e.target.value)}
								variant="outlined"
								size="small"
								fullWidth
								style={{ minWidth: "150px" }}
							/>
						</Grid>
						<Grid item md={12}>
							<TextField
								aria-readonly
								label="Confirm Password"
								value={confirmPassword}
								onChange={(e) => setConfirmPassword(e.target.value)}
								variant="outlined"
								size="small"
								fullWidth
								style={{ minWidth: "150px" }}
							/>
						</Grid>
					</Grid>
				</DialogContent>
				<DialogActions>
					<Button autoFocus onClick={handleCancel} color="primary">
						Cancel
					</Button>
					<Button
						onClick={handleOk}
						color="primary"
						variant="contained"
						disabled={!canChange}
					>
						Change Password
					</Button>
				</DialogActions>
			</Dialog>
			<ErrorModal error={error} onHide={() => setError("")} />
		</>
	);
}
